const voices = [
  {
    id: 1,
    quote:
      'Mein Anliegen war die Frage, wie ich ein Team führen soll, das mich nicht als Chefin akzeptiert. Während der Coachingsitzungen wurde klar, was ich selbst zu dieser Dynamik beigetragen habe. Seitdem fühle ich mich sicherer und mein Team meldet das durch gute Zusammenarbeit zurück. Das Wichtigste für mich war, aufzuhören mich zu erklären, wenn ich eine Entscheidung treffen muss.',
    attribution: 'Geschäftsführerin, mittelständisches Unternehmen',
  },
  {
    id: 2,
    quote:
      'Unser Führungskreis hatte sich in Grabenkämpfen festgefahren, die niemand offen ansprach. Wir haben uns daher für einen gemeinsamen Workshop entschieden. Er war ein Raum, in dem wir zum ersten Mal gemeinsam gesehen haben, wie unser System tatsächlich funktioniert. Das war nicht immer angenehm. Aber die Gespräche, die seitdem möglich sind, hätte ich vorher nicht für möglich gehalten.',
    attribution: 'Bereichsleiter, Technologieunternehmen',
  },
  {
    id: 3,
    quote:
      'Vor einem sehr wichtigen Karriereschritt habe ich mich trotz meiner Erfahrung für eine Verhandlungsbegleitung entschieden. Das war eine sehr gute Entscheidung. Ich habe typische, zumeist hinderliche Verhaltensmuster erkannt. Frau Braun spiegelte mir diese präzise und ohne Umschweife. Genau diese Klarheit hat mir gefehlt.',
    attribution: 'Partnerin, Unternehmensberatung',
  },
  {
    id: 4,
    quote:
      'Ich bin mit der Begleitung durch Fr. Prof. Braun außerordentlich zufrieden, da sie mir aktiv zuhört und präzise auf meine individuellen Wünsche eingeht. Sie verbindet ihr umfassendes Fachwissen und höchste Professionalität mit einer ausgeprägten Empathie. Besonders wertvoll sind für mich ihre konkreten, direkt umsetzbaren Tipps für meinen Führungsalltag.',
    attribution: 'Abteilungsleiterin Verteidigungsindustrie',
  },
  {
    id: 5,
    quote:
      'Im Verlauf eines unserer Projekte entstanden persönliche Differenzen innerhalb der Projektleitung, die den Projekterfolg ernsthaft zu gefährden drohten. Durch zielorientierte Mediation von Frau Braun konnten die Konflikte konstruktiv aufgelöst werden. Die Zusammenarbeit wurde wieder auf ein professionelles Niveau gehoben, die Kommunikation klarer und das gegenseitige Vertrauen gestärkt.',
    attribution: 'Abteilungsleiter Verteidigungssektor',
  },
  {
    id: 6,
    quote:
      'Ich bin direkt nach dem Studium in die Unternehmensberatung gestartet und habe schnell gemerkt, dass gute Inhalte allein nicht reichen. Mit Frau Braun habe ich daran gearbeitet, wie ich vor dem Management präsentiere und wie ich mich gegenüber Kollegen und Vorgesetzten positioniere. Sie hat mir ehrlich gespiegelt, wo meine Wirkung noch nicht zu meinem Anspruch passte, und mir gleichzeitig sehr konkrete Werkzeuge an die Hand gegeben. Ich bin überzeugt, dass mich das Coaching schneller zum Senior Consultant gebracht hat. Und die Werkzeuge nutze ich bis heute in meiner täglichen Arbeit.',
    attribution: 'Senior Consultant, Unternehmensberatung',
  },
];

export default voices;
